var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrderHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "7sxjtohwva",
    d: "M0 0h56.703v92.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xe5oizzm2c",
    d: "M0 0h36.96v92.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ih1yqfpu9e",
    d: "M0 0h56.703v92.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "usc3fe0rzg",
    d: "M0 0h56.703v92.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ewolxex4fi",
    d: "M0 0h33.07v92.704H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vmv7cvzypk",
    d: "M0 127.129h360V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v360H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M24.913 125.044h334.576v-7.55H24.913z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.74 9.916a1.38 1.38 0 1 1-2.45-.872h2.138c.195.237.311.541.311.872",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.874 34.425s-7.864 0-10.076 16.584c-1.033 7.743-9.028 21.471-9.028 21.471s-16.869 23.391-19.294 31.303c-.223.73-.07 1.531.428 2.109 1.755 2.03 4.227-2.914 4.227-2.914l31.962-46.113 1.781-22.44z",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m305.906 60.555-2.813-3.69-35.858 49.297s3.164 2.428 9.264-5.867c6.1-8.296 29.407-39.74 29.407-39.74",
    fill: "#DD997F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.664 121.007a.51.51 0 0 1-.602.602l-81.47-16.962-1.368-.285-.007-.002a1.793 1.793 0 0 1-1.227-.94 2.82 2.82 0 0 1-.3-1.277l.001-.097c.046-1.426 1.352-2.48 2.758-2.264.132.02.27.044.411.07l.318.061c8.053 1.568 74.712 15.448 79.94 16.61.197.045.89 1.26.93 1.457l.616 3.027z",
    fill: "#915227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.763 121.152a.51.51 0 0 1-.602.602l-81.47-16.962-1.368-.285-.007-.001a1.793 1.793 0 0 1-1.227-.941 2.82 2.82 0 0 1-.3-1.277v-.096c.047-1.427 1.353-2.48 2.759-2.264.132.02.27.043.411.07l.318.06c8.053 1.568 75.253 16.509 80.481 17.671a.51.51 0 0 1 .389.397l.616 3.026z",
    fill: "#C1783D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.908 121.007a.51.51 0 0 1-.602.602l-81.47-16.962-1.367-.285-.008-.002a1.793 1.793 0 0 1-1.227-.94 2.82 2.82 0 0 1-.3-1.277l.001-.097c.047-1.426 1.352-2.48 2.758-2.264.133.02.27.044.411.07l.318.061c8.053 1.568 74.712 15.448 79.941 16.61.196.045.889 1.26.929 1.457l.616 3.027z",
    fill: "#F7A75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.997 34.906v-5.49c0-2.308.252-4.608.755-6.86.85-3.805 2.644-10.964 2.264-14.657-.57-5.53-2.484-10.472-5.737-6.406.194.008 1.96.025 1.96.025s2.547 4.191 1.571 10.29c-.976 6.1-2.846 13.908-2.928 16.348-.081 2.44 0 6.75 0 6.75h2.115z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.093 34.906s13.185-6.153 16.823 21.79a21.767 21.767 0 0 0 3.795 9.716c10.377 14.74 39.397 54.197 36.017 59.478-3.904 6.1-64.687-85.372-56.635-90.984",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(303.093 34.425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n9c445u4gb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7sxjtohwva"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.781 0 0 22.44l45.381 59.533s4.88 5.612 5.124 8.784c.488 3.171 7.076 1.951 6.1 0-.976-1.952-43.674-56.85-45.382-69.78C9.515 8.044 11.053 0 1.781 0",
    fill: "#FFDCC5",
    mask: "url(#n9c445u4gb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.225 9.044a1.38 1.38 0 1 1-2.14 0h2.14z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.757 60.555-1.472-3.69-18.767 49.297s1.656 2.428 4.848-5.867c3.193-8.296 15.391-39.74 15.391-39.74",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.615 121.007c.048.36-.159.677-.392.602l-53.104-16.962-.89-.285a.33.33 0 0 1-.006-.002c-.344-.11-.64-.458-.8-.94a4.098 4.098 0 0 1-.195-1.277v-.097c.031-1.426.882-2.48 1.798-2.264a6.1 6.1 0 0 1 .269.07l.207.061c5.249 1.568 48.698 15.448 52.106 16.61.128.045.58 1.26.605 1.457l.402 3.027z",
    fill: "#7C6D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68 121.152c.047.36-.16.677-.393.602l-53.103-16.962-.891-.285-.005-.001c-.344-.111-.64-.459-.8-.941a4.098 4.098 0 0 1-.195-1.373c.03-1.427.882-2.48 1.798-2.264a6.1 6.1 0 0 1 .268.07l.207.06c5.25 1.568 49.05 16.509 52.459 17.671.128.044.227.2.253.397l.402 3.026z",
    fill: "#A0908D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.774 121.007c.048.36-.159.677-.392.602l-53.103-16.962-.891-.285a.33.33 0 0 1-.005-.002c-.345-.11-.64-.458-.8-.94a4.098 4.098 0 0 1-.196-1.277v-.097c.031-1.426.882-2.48 1.798-2.264a6.1 6.1 0 0 1 .269.07l.207.061c5.249 1.568 48.698 15.448 52.106 16.61.128.045.58 1.26.606 1.457l.401 3.027z",
    fill: "#B7A8A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.705 9.916c0 .762-.691 1.38-1.544 1.38-.852 0-1.542-.618-1.542-1.38 0-.331.13-.635.347-.872h2.392c.216.237.347.541.347.872",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.038 34.906v-5.49c0-2.308.282-4.608.844-6.86.95-3.805 2.955-10.964 2.53-14.657-.637-5.53-2.776-10.472-6.411-6.406.216.008 2.19.025 2.19.025s2.847 4.191 1.756 10.29c-1.091 6.1-3.182 13.908-3.272 16.348-.091 2.44 0 6.75 0 6.75h2.363z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266 35.426s8.595-6.153 10.966 21.791c.297 3.498 1.15 6.83 2.473 9.715 6.764 14.74 25.68 54.198 23.477 59.479-2.545 6.1-42.163-85.373-36.915-90.985",
    fill: "#DDD5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.162 34.425s-5.126 0-6.569 16.584c-.673 7.743-5.884 21.471-5.884 21.471s-10.995 23.391-12.576 31.303c-.145.73-.046 1.531.28 2.109 1.143 2.03 2.754-2.914 2.754-2.914l20.834-46.113 1.16-22.44z",
    fill: "#BFB2AC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(266 34.425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ep94umi7rd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xe5oizzm2c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.161 0 0 22.44l29.58 59.533s3.18 5.612 3.34 8.784c.318 3.171 4.612 1.951 3.976 0-.637-1.952-28.467-56.85-29.58-69.78C6.201 8.044 7.203 0 1.16 0",
    fill: "#CFC6C2",
    mask: "url(#ep94umi7rd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.75 34.425s-7.864 0-10.077 16.584c-1.033 7.743-9.027 21.471-9.027 21.471s-16.869 23.391-19.294 31.303c-.224.73-.07 1.531.428 2.109 1.755 2.03 4.227-2.914 4.227-2.914l31.962-46.113 1.78-22.44z",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.781 60.555-2.812-3.69-35.859 49.297s3.165 2.428 9.264-5.867c6.1-8.296 29.407-39.74 29.407-39.74",
    fill: "#DD997F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.54 121.007a.51.51 0 0 1-.602.602l-81.47-16.962-1.368-.285-.007-.002a1.793 1.793 0 0 1-1.228-.94 2.822 2.822 0 0 1-.3-1.277c0-.033 0-.065.002-.097.046-1.426 1.352-2.48 2.757-2.264.133.02.27.044.412.07l.318.061c8.053 1.568 74.712 15.448 79.94 16.61.196.045.89 1.26.93 1.457l.616 3.027z",
    fill: "#915227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.639 121.152a.51.51 0 0 1-.602.602l-81.47-16.962-1.368-.285-.007-.001a1.793 1.793 0 0 1-1.228-.941 2.822 2.822 0 0 1-.3-1.277c0-.032 0-.064.002-.096.046-1.427 1.352-2.48 2.757-2.264.133.02.27.043.412.07l.318.06c8.053 1.568 75.252 16.509 80.481 17.671a.51.51 0 0 1 .388.397l.617 3.026z",
    fill: "#C1783D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.784 121.007a.51.51 0 0 1-.602.602l-81.47-16.962-1.368-.285a1.793 1.793 0 0 1-1.235-.943 2.82 2.82 0 0 1-.3-1.276c0-.033 0-.065.002-.097.046-1.426 1.352-2.48 2.757-2.264.133.02.27.044.412.07l.318.061c8.053 1.568 74.712 15.448 79.94 16.61.197.045.89 1.26.93 1.457l.616 3.027z",
    fill: "#F7A75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.873 34.906v-5.49c0-2.308.252-4.608.755-6.86.85-3.805 2.643-10.964 2.263-14.657-.569-5.53-2.483-10.472-5.736-6.406.194.008 1.96.025 1.96.025s2.547 4.191 1.57 10.29c-.975 6.1-2.846 13.908-2.927 16.348-.081 2.44 0 6.75 0 6.75h2.115z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.969 34.906s13.185-6.153 16.823 21.79a21.767 21.767 0 0 0 3.794 9.716c10.377 14.74 39.397 54.197 36.017 59.478-3.903 6.1-64.686-85.372-56.634-90.984",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.969 34.425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xdfqdo3qxf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ih1yqfpu9e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.781 0 0 22.44l45.381 59.533s4.88 5.612 5.124 8.784c.488 3.171 7.076 1.951 6.1 0-.976-1.952-43.674-56.85-45.382-69.78C9.515 8.044 11.053 0 1.781 0",
    fill: "#FFDCC5",
    mask: "url(#xdfqdo3qxf)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.117 9.916a1.38 1.38 0 1 1-2.45-.872h2.139c.195.237.31.541.31.872",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.252 34.425s-7.865 0-10.077 16.584c-1.033 7.743-9.028 21.471-9.028 21.471s-16.868 23.391-19.293 31.303c-.224.73-.071 1.531.428 2.109 1.754 2.03 4.226-2.914 4.226-2.914l31.962-46.113 1.782-22.44z",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.283 60.555-2.813-3.69-35.858 49.297s3.164 2.428 9.264-5.867c6.1-8.296 29.407-39.74 29.407-39.74",
    fill: "#DD997F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.041 121.007a.51.51 0 0 1-.602.602l-81.47-16.962-1.367-.285-.008-.002a1.793 1.793 0 0 1-1.227-.94 2.82 2.82 0 0 1-.3-1.277l.001-.097c.047-1.426 1.352-2.48 2.758-2.264.133.02.27.044.412.07l.318.061c8.052 1.568 74.711 15.448 79.94 16.61.196.045.889 1.26.93 1.457l.615 3.027z",
    fill: "#915227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14 121.152a.51.51 0 0 1-.602.602l-81.47-16.962-1.367-.285-.008-.001a1.793 1.793 0 0 1-1.227-.941 2.82 2.82 0 0 1-.3-1.277l.001-.096c.047-1.427 1.352-2.48 2.758-2.264.133.02.27.043.412.07l.317.06c8.053 1.568 75.253 16.509 80.482 17.671a.51.51 0 0 1 .388.397l.616 3.026z",
    fill: "#C1783D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.285 121.007a.51.51 0 0 1-.601.602l-81.471-16.962-1.367-.285a1.793 1.793 0 0 1-1.235-.943 2.822 2.822 0 0 1-.3-1.276l.001-.097c.047-1.426 1.352-2.48 2.758-2.264.133.02.27.044.412.07l.318.061c8.053 1.568 74.712 15.448 79.94 16.61.196.045.89 1.26.93 1.457l.615 3.027z",
    fill: "#F7A75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.445 9.044c-.006 3.882-1.547 10.07-2.316 13.512a31.461 31.461 0 0 0-.755 6.86v5.49h-2.114s-.004-.177-.008-.481c-.018-1.193-.057-4.325.008-6.27.081-2.439 1.952-10.247 2.927-16.346.156-.974.222-1.899.223-2.765.005-4.566-1.793-7.526-1.793-7.526s-1.767-.017-1.96-.025c1.767-2.21 3.14-1.76 4.115 0 .82 1.478 1.361 3.88 1.62 6.406.037.352.054.736.053 1.145",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.47 34.906s13.185-6.153 16.823 21.79a21.765 21.765 0 0 0 3.795 9.716c10.377 14.74 39.397 54.197 36.017 59.478-3.904 6.1-64.686-85.372-56.635-90.984",
    fill: "#F2C999"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.47 34.425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ixirqjw9ih",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#usc3fe0rzg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.781 0 0 22.44l45.381 59.533s4.88 5.612 5.124 8.784c.488 3.171 7.076 1.951 6.1 0-.976-1.952-43.674-56.85-45.382-69.78C9.515 8.044 11.053 0 1.781 0",
    fill: "#FFDCC5",
    mask: "url(#ixirqjw9ih)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.147 121.007c.043.36-.142.677-.35.602l-47.515-16.962-.797-.285a.246.246 0 0 0-.005-.002c-.308-.11-.573-.458-.715-.94a4.541 4.541 0 0 1-.175-1.277v-.097c.028-1.426.789-2.48 1.609-2.264.077.02.157.044.24.07l.185.061c4.697 1.568 43.573 15.448 46.622 16.61.114.045.518 1.26.542 1.457l.36 3.027z",
    fill: "#B7A8A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.347 9.916a1.38 1.38 0 1 1-2.45-.872h2.14c.194.237.31.541.31.872",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.717 9.044c-.006 3.882-1.547 10.07-2.316 13.512a31.488 31.488 0 0 0-.755 6.86v5.49h-2.115l-.006-.368c-.018-1.093-.06-4.372.006-6.382.082-2.44 1.952-10.248 2.928-16.347.156-.974.222-1.899.223-2.765.005-4.566-1.793-7.526-1.793-7.526s-1.767-.017-1.96-.025c1.767-2.21 3.14-1.76 4.115 0 .82 1.478 1.361 3.88 1.62 6.406.037.352.054.736.053 1.145",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.928 35.426s7.69-6.153 9.812 21.791c.265 3.498 1.028 6.83 2.213 9.715 6.052 14.74 22.976 54.198 21.005 59.479-2.277 6.1-37.725-85.373-33.03-90.985",
    fill: "#DDD5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.967 34.425s-4.586 0-5.877 16.584c-.602 7.743-5.264 21.471-5.264 21.471s-9.838 23.391-11.253 31.303c-.13.73-.041 1.531.25 2.109 1.023 2.03 2.465-2.914 2.465-2.914l18.64-46.113 1.04-22.44z",
    fill: "#BFB2AC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.928 34.425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p3s85ru3cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ewolxex4fi"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.039 0 0 22.44l26.467 59.533s2.846 5.612 2.988 8.784c.284 3.171 4.126 1.951 3.557 0-.569-1.952-25.47-56.85-26.467-69.78C5.55 8.044 6.446 0 1.04 0",
    fill: "#CFC6C2",
    mask: "url(#p3s85ru3cj)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "4bc1bef6vl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vmv7cvzypk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    mask: "url(#4bc1bef6vl)",
    d: "M82.265 37.226h3.351V10.695h-3.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFC6C2",
    mask: "url(#4bc1bef6vl)",
    d: "M82.265 11.336h3.351V0h-3.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A75A",
    mask: "url(#4bc1bef6vl)",
    d: "M1.642 114.228h164.313v-5.394H1.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.974 34.337V54.85l-6.045 4.377c0 .001 0 0 0 0L.218 115.512c-1.022-9.105 1.827-11.608 2.638-12.127.227-.145.454-.29.675-.446L55.768 66.03c6.01-4.246 10.63-10.821 12.79-18.65.08-.29.157-.582.23-.878 1.054-4.197 4.162-7.246 7.294-9.337a29.877 29.877 0 0 1 3.641-2.063l.004-.001a12.593 12.593 0 0 1 4.247-.764",
    fill: "#F2C999",
    mask: "url(#4bc1bef6vl)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.728 115.512 90.09 59.28l-6.115-4.43V34.337h.082c1.298 0 2.552.196 3.733.562l.017.006c1.48.685 3.219 1.623 4.898 2.845l.002.002c2.833 2.061 5.494 4.93 6.453 8.75.074.296.15.589.23.878 2.16 7.829 6.78 14.404 12.79 18.65l52.236 36.91c.22.156.448.3.675.445.812.52 3.66 3.022 2.638 12.127",
    fill: "#FFDCC5",
    mask: "url(#4bc1bef6vl)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrderHistory);
export default __webpack_public_path__ + "static/media/no-order-history.ad721f002a25505da0ff21225fc009a0.svg";
export { ForwardRef as ReactComponent };